import { WebshopProduct } from '@cldsystems/ws-api-client';
import { ERRORS } from '@/constants/error';
import { useAppContext } from '@/providers/app-provider/app-provider';
import { List } from '@/types/common';

export const useProductsContext = () => {
  const context = useAppContext<{ products: List<WebshopProduct> }>();
  if (!context.products) {
    throw ERRORS.REGULAR('products must be passed to <Page/> context');
  }
  return context.products;
};
